import { createSelector } from "reselect";

// types
import IRootState from "models/IRootState";

export const isLoadingSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.isLoading
);

export const userSelector = createSelector(
  (state: IRootState) => state.auth,
  (auth) => ({
    id: auth?.currentuserinfo?.id,
    currentuserinfo: auth?.currentuserinfo,
    verifytoken: auth?.verifytoken,
    authtoken: auth?.authtoken,
    isuserlogin: auth?.isuserLogin,
    accesslevel: auth?.access_level,
    isFRVerified: auth?.isFRVerified,
  })
);

export const currentUserSelector = createSelector(
  (state: IRootState) => state.auth,
  (auth) => ({
    ...auth?.currentuserinfo,
  })
);
export const otpSelector = createSelector(
  (state: IRootState) => state.auth,
  (auth) => ({
    isotpreceived: auth.isotpreceived,
    is_fr_verification_in_progress: auth.is_fr_verification_in_progress,
    authtoken: auth.authtoken,
    verifytoken: auth.verifytoken,
    frError: auth.frError,
    is_in_api_call: auth.is_in_api_call,
    isotpverified: auth.isotpverified,
    otperrormessage: auth.otperrormessage,
  })
);
